RivalIQ.apps.Dashboard.module('models', function (models, App, Backbone, Marionette, $, _) {

    'use strict';

    models.StateMachine = Marionette.Object.extend({
        initialize: function (model) {
            const me = this;
            me.model = model;
            me.state = _.result(me, 'initialState');
            me._bindEvents();
        },

        _executeTransition: function (transitions) {
            const me = this;

            const prev = me.state;
            const nextState = _.reduce(transitions, function (result, transition) {
                if (!result && transition[0] === me.state) {
                    const predicate = _.last(transition);
                    return (!predicate || predicate.call(me) ? transition[1] : undefined);
                }

                return result;
            }, undefined);

            if (nextState) {
                me.state = nextState;
                me.triggerMethod('transition', prev, nextState);
            }
        },

        _bindEvents: function () {
            const me = this;

            const events = _.mapValues(_.result(me, 'events'), function (transitions) {
                return _.bind(me._executeTransition, me, transitions);
            });

            Marionette.bindEntityEvents(me, me.model, events);
        }
    });

    models.StateMachine.isValid = function () {
        const me = this;
        return me.model.isValid();
    };
});
